// src/services/downloadService.js
import axios from 'axios';
import { toast } from 'react-toastify';
import { Method_GET_CONTEXTO_PDF } from './api';

const API_BASE_URL = '/portal/rest/contador/ordem-servico/documento/download';
const API_BASE_URL_DOWN = '/portal/rest/contador/ordem-servico/certificado/arquivo/download';
const API_DOWNLOAD_DOC_CONTEXT = "/portal/rest/cliente/arquivo/download";


export const ServiceDownloadDocumento = async (id, filename) => {
  try {
    const response = await axios.get(`${API_BASE_URL}`, {
      params: { id, filename },
      responseType: 'blob', // Define o tipo da resposta como blob para lidar com arquivos
    });

    // Valida se a resposta foi recebida
    if (response) {
      toast.success("Download realizado com sucesso!");

      // Cria uma URL para o blob e simula o download
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', filename); // Nome do arquivo para o download
      document.body.appendChild(link);
      link.click();
      link.remove();

      // Libera a memória alocada para o blob
      window.URL.revokeObjectURL(url);
    } else {
      toast.error("Não foi possível realizar o download do arquivo.");
    }
  } catch (error) {
    // Trata diferentes tipos de erro
    if (error.response && error.response.status === 406) {
      toast.error("Formato de arquivo não aceito pelo servidor.");
    } else {
      toast.error(`Erro ao fazer o download do arquivo: ${error.message}`);
    }
    console.error("Erro no download:", error);
    throw error; // Relança o erro para permitir o tratamento em outro nível, se necessário
  }
};

export const ServiceDownloadDocumentoContexto = async (filename) => {
  try {
    const response = await axios.get(`${API_DOWNLOAD_DOC_CONTEXT}`, {
      params: { filename },
      responseType: 'blob', // Define o tipo da resposta como blob para lidar com arquivos
    });

    // Valida se a resposta foi recebida
    if (response) {
      toast.success("Download realizado com sucesso!");

      // Cria uma URL para o blob e simula o download
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', filename); // Nome do arquivo para o download
      document.body.appendChild(link);
      link.click();
      link.remove();

      // Libera a memória alocada para o blob
      window.URL.revokeObjectURL(url);
    } else {
      toast.error("Não foi possível realizar o download do arquivo.");
    }
  } catch (error) {
    // Trata diferentes tipos de erro
    if (error.response && error.response.status === 406) {
      toast.error("Formato de arquivo não aceito pelo servidor.");
    } else {
      toast.error(`Erro ao fazer o download do arquivo: ${error.message}`);
    }
    console.error("Erro no download:", error);
    throw error; // Relança o erro para permitir o tratamento em outro nível, se necessário
  }
};

export const ServiceDownloadCertificadoDigital = async (clienteId, filename) => {
  try {
    // Realiza a requisição para o download
    const response = await axios.get(API_BASE_URL_DOWN, {
      params: { clienteId, filename },
      responseType: 'blob', // Para lidar com arquivos
    });

    // Valida se a resposta foi recebida
    if (response && response.data) {
      toast.success('Download realizado com sucesso!');

      // Cria uma URL para o blob e inicia o download
      const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/p12' }));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', filename); // Utiliza o filename completo para o download
      document.body.appendChild(link);
      link.click();
      link.remove();

      // Libera a memória alocada para o blob
      window.URL.revokeObjectURL(url);
    } else {
      toast.error('Não foi possível realizar o download do arquivo.');
    }
  } catch (error) {
    // Trata erros na requisição
    if (error.response && error.response.status === 406) {
      toast.error('Formato de arquivo não aceito pelo servidor.');
    } else {
      toast.error(`Erro ao fazer o download do arquivo: ${error.message}`);
    }
    console.error('Erro no download:', error);
    throw error;
  };
};

export async function serviceDownloadBalancete(dataInicio, dataTermino) {
  const url = `/empresa/contabilidade/balancete/download`;

  try {
    const res = await Method_GET_CONTEXTO_PDF(url, {
      params: { dataInicio, dataTermino },
      responseType: 'blob',
    });

    // cria o blob corretamente
    const blob = new Blob([res.data], { type: 'application/pdf' });
    const objectUrl = URL.createObjectURL(blob);

    // cria link para download
    const link = document.createElement('a');
    link.href = objectUrl;
    link.download = `balancete.pdf`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    URL.revokeObjectURL(objectUrl);

    toast.success("Download realizado com sucesso!");
  } catch (err) {
    toast.error("Erro ao baixar balancete. Tente novamente.");
    console.error(err);
  }
};